import React, { useEffect } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Cross2Icon } from "@radix-ui/react-icons";
import { Button } from "../ui/button";
import { getTemplateUsageInSetsById } from "../../api/admin/templates";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import Loader from "../common/loader/loader";

const DeleteTemplateDialog = ({
  open,
  onClose,
  template,
  onTemplateDelete,
}: any) => {
  const [loading, setLoading] = React.useState<any>(true);

  const [usage, setUsage] = React.useState<any | null | false>(null);
  const [loadingUsageError, setLoadingUsageError] = React.useState<any>(null);

  const loadPrintLocationUsage = async (templateId: string) => {
    const response = await getTemplateUsageInSetsById(templateId);
    console.log("response", response);

    if (!response) {
      setLoadingUsageError("Error loading print location usage data.");
      setLoading(false);
      return;
    }

    if (response && response.data) {
      setLoadingUsageError(null);
      setUsage(response.data);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (template?._id) {
      loadPrintLocationUsage(template?._id);
    }

    return () => {
      setUsage(null);
      setLoadingUsageError(null);
      setLoading(true);
    };
  }, [template?._id]);

  return (
    <Dialog.Root open={open} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="bg-[rgba(0,0,0,.6)] data-[state=open]:animate-overlayShow fixed inset-0" />

        <Dialog.Content className="data-[state=open]:animate-contentShow fixed top-[50%] left-[50%] max-h-[90vh] w-full max-w-[60vw] translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-blackLight p-[25px] shadow-[hsl(206, 22%, 93%) 0px 10px 38px -10px, hsl(206, 22%, 93%) 0px 10px 20px -15px] focus:outline-none text-body">
          <Dialog.Title className="text-mauve12 m-0 text-[17px] font-medium">
            Delete Template
          </Dialog.Title>

          {/* <div className="my-8 flex flex-col">
            <div className="w-full h-full  flex items-start gap-x-2 border-t border-borderColor pt-2">
              Are you sure you want to delete the template{" "}
              <span className="font-bold">{template?.internalName}</span>?
            </div>
          </div> */}

          <div className="my-8 flex flex-col items-center justify-center">
            {loading && !loadingUsageError && <Loader />}

            {!loading && loadingUsageError && (
              <div className="text-red-500">{loadingUsageError}</div>
            )}

            {!loading && !loadingUsageError && usage && usage?.length > 0 && (
              <div className="w-full h-full flex flex-col items-start gap-x-2 border-t border-borderColor pt-2">
                <div>
                  This template "
                  <span className="font-bold">{template?.internalName}</span>"
                  is being used in these sets:
                </div>
                <ScrollArea.Root className="mt-2 w-full relative h-[100px] overflow-hidden">
                  <ScrollArea.Viewport className="w-full h-full /py-2 px-2 relative rounded bg-borderColor">
                    {usage && (
                      <div className=" flex flex-col font-bold my-2">
                        {usage?.map((template: any) => (
                          <span key={template._id} className="text-primary">
                            {template.slug}
                          </span>
                        ))}
                      </div>
                    )}
                  </ScrollArea.Viewport>
                  <ScrollArea.Scrollbar
                    className="flex select-none touch-none p-0.5 transition-colors duration-[160ms] ease-out hover:bg-black data-[orientation=vertical]:w-2.5"
                    orientation="vertical"
                  >
                    <ScrollArea.Thumb className="flex-1 bg-scrollbarColor rounded-[10px]" />
                  </ScrollArea.Scrollbar>
                </ScrollArea.Root>
              </div>
            )}

            {!loading &&
              !loadingUsageError &&
              (!usage || (usage && !usage?.length)) && (
                <div className="w-full h-full  flex flex-col items-start gap-x-2 border-t border-borderColor pt-2">
                  <div>
                    This template "
                    <span className="font-bold">{template?.internalName}</span>"
                    is not being used in any sets, are you sure you want to
                    delete it?
                  </div>
                </div>
              )}
          </div>

          <div className="py-2 h-full w-full flex items-end gap-x-2 justify-end ">
            <Button onClick={() => onClose()}>Cancel</Button>
            <Button
              onClick={() => onTemplateDelete(template?._id)}
              className="bg-red-500 hover:bg-red-600"
            >
              {usage && usage?.length > 0 ? "Delete Anyway" : "Delete"}
            </Button>
          </div>

          <Dialog.Close asChild>
            <button
              className="text-white hover:text-primary focus:shadow-violet7 absolute top-[10px] right-[10px] inline-flex h-[25px] w-[25px] appearance-none items-center justify-center rounded-full focus:shadow-[0_0_0_2px] focus:outline-none"
              aria-label="Close"
            >
              <Cross2Icon />
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default DeleteTemplateDialog;
